import type { ButtonHTMLAttributes, ReactNode } from 'react'
import { Icon, type IconName } from './icon'

type Variant = 'primary' | 'secondary' | 'ghost' | 'danger'

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: Variant
  size?: 'sm'
  icon?: IconName
  kbd?: string
  children?: ReactNode
}

export function Button({
  variant = 'secondary',
  size,
  icon,
  kbd,
  children,
  className,
  type = 'button',
  ...rest
}: ButtonProps) {
  const cls = ['btn', `btn-${variant}`, size === 'sm' ? 'btn-sm' : '', className]
    .filter(Boolean)
    .join(' ')
  return (
    <button type={type} className={cls} {...rest}>
      {icon && <Icon name={icon} size={size === 'sm' ? 12 : 14} />}
      {children}
      {kbd && (
        <span className="kbd" style={{ marginLeft: 6 }}>
          {kbd}
        </span>
      )}
    </button>
  )
}

type IconButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  icon: IconName
  tooltip?: string
}

export function IconButton({ icon, tooltip, type = 'button', ...rest }: IconButtonProps) {
  return (
    <button type={type} className="icon-btn" title={tooltip} aria-label={tooltip} {...rest}>
      <Icon name={icon} size={16} />
    </button>
  )
}
